"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _statusTag = _interopRequireDefault(require("./status-tag"));

var _dismissibleTag = _interopRequireDefault(require("./dismissible-tag"));

var Tag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return props.onClose && (props.type === "theme" || props.type === "neutral") && props.children ? /*#__PURE__*/_react["default"].createElement(_dismissibleTag["default"], {
    onClose: props.onClose,
    closeLabel: props.closeLabel,
    type: props.type,
    ref: ref,
    "aria-label": props["aria-label"]
  }, props.children) : /*#__PURE__*/_react["default"].createElement(_statusTag["default"], {
    type: props.type,
    ref: ref,
    "aria-label": props["aria-label"]
  }, props.children);
});

Tag.displayName = "Tag";
Tag.propTypes = {
  /**
   * An accessible label for the component. This will not be visible in the UI,
   * but will be read by screen readers. This is particularly helpful for
   * compact tags which don't have textual content.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  "aria-label": _propTypes["default"].string,

  /**
   * The tag's label. Omit this to render a compact tag.
   */
  children: _propTypes["default"].string,

  /**
   * An accessible label for the tag's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   *
   * @since 4.x
   */
  closeLabel: _propTypes["default"].string,

  /**
   * The visual style of the tag.
   */
  type: _propTypes["default"].oneOf(["theme", "neutral", "success", "warning", "error"]),

  /**
   * If `type` is set to `"theme"` or `"neutral"`, a function can be provided
   * here to render a dismissable tag.
   *
   * This prop will be ignored for compact tags (if `children` is not set) or
   * for tags that are not of type `"theme"` or `"neutral"`.
   */
  onClose: _propTypes["default"].func
};
Tag.defaultProps = {
  type: "theme"
};
var _default = Tag;
exports["default"] = _default;